import {
    GET_KEY_REQUEST,
    GET_KEY_SUCCESS,
    GET_KEY_FAILURE,
    CREATE_KEY_REQUEST,
    CREATE_KEY_SUCCESS,
    CREATE_KEY_FAILURE,
    UPDATE_KEY_REQUEST,
    UPDATE_KEY_SUCCESS,
    UPDATE_KEY_FAILURE,
    DELETE_KEY_REQUEST,
    DELETE_KEY_SUCCESS,
    DELETE_KEY_FAILURE,
    GET_KEYBYID_REQUEST,
    GET_KEYBYID_SUCCESS,
    GET_KEYBYID_FAILURE,
    GET_KEY_KEYTYPE_REQUEST,
    GET_KEY_KEYTYPE_SUCCESS,
    GET_KEY_KEYTYPE_FAILURE,
    GET_KEY_BY_TYPE_EXISTS_REQUEST,
    GET_KEY_BY_TYPE_EXISTS_SUCCESS,
    GET_KEY_BY_TYPE_EXISTS_FAILURE,
    GET_USER_SYSTEM_KEY_PERMISSION_SUCCESS,
    GET_USER_SYSTEM_KEY_PERMISSION_FAILURE,
    GET_KEY_CATALOG_SUCCESS,
    GET_KEY_CATALOG_FAILURE,
    VALIDATE_KEY_SUCCESS,
    VALIDATE_KEY_FAILURE,
  } from './actions';
  import {USER_LOGOUT_SUCCESS} from '../userLogin/actions';

  const initialState = {
    keyCatalog: [],
    validateKeyResult: null,
    getKeyListResult: { success: true },
    keys: { Items: [] },
    createKeyResult: { success: true },
    updateKeyResult: { success: true },
    deleteKeyResult: { success: true },
    getKeyByIdResult: { success: true },
    getKeyByTypeResult: { success: true },
    getKeyByTypeExistsResult: { success: true },
    getUserSystemKeyPermissionResult: { success: true },
    selectedKey: null,
    loading: false,
    error: null,
    apiKey: null,
    keyExists: false,
    checkedKeys:false,
    permission: null,
  };
  
  export default (state = initialState, action) => {
    let keys = { Items: [] };
    switch (action.type) {
      case GET_KEY_CATALOG_SUCCESS:
        return { ...state, keyCatalog: (action.payload.catalog && action.payload.catalog.keyTypes) || [] };
      case GET_KEY_CATALOG_FAILURE:
        return { ...state, keyCatalog: [] };
      case VALIDATE_KEY_SUCCESS:
        return { ...state, validateKeyResult: action.payload.result };
      case VALIDATE_KEY_FAILURE:
        return { ...state, validateKeyResult: { ok: false, message: (action.payload.error && action.payload.error.message) || "Could not test the key." } };
      case GET_KEY_REQUEST:
      case CREATE_KEY_REQUEST:
      case UPDATE_KEY_REQUEST:
      case DELETE_KEY_REQUEST:
      case GET_KEYBYID_REQUEST:
      case GET_KEY_KEYTYPE_REQUEST:
      case GET_KEY_BY_TYPE_EXISTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };

      case USER_LOGOUT_SUCCESS:
            return {
                ...state,
                keyExists: false,
                checkedKeys: false
            };
  
      case GET_KEY_SUCCESS:
        keys = action.payload.keys;
        return {
          ...state,
          getKeyListResult: { success: true },
          keys,
          loading: false,
        };
  
      case GET_KEY_FAILURE:
        return {
          ...state,
          getKeyListResult: { success: false, ...action.payload.error },
          keys: { Items: [] },
          loading: false,
        };
  
      case CREATE_KEY_SUCCESS:
        if (action.payload && action.payload.keys) {
          return {
              ...state,
              createKeyResult: { success: true },
              keys: { Items: [...(state.keys.Items || []).filter(item => item !== undefined), action.payload.keys] },
              loading: false,
          };
      } else {
          return {
              ...state,
              createKeyResult: { success: false, error: "Invalid key data" },
              loading: false,
          };
      }
  
      case CREATE_KEY_FAILURE:
        return {
          ...state,
          createKeyResult: { success: false, ...action.payload.error },
          loading: false,
        };
  
      case UPDATE_KEY_SUCCESS:
        const updatedKey = action.payload.keys;
        keys = {
          Items: state.keys.Items.map((key) =>
            key.keyId === updatedKey.keyId ? updatedKey : key
          ),
        };
        return {
          ...state,
          updateKeyResult: { success: true },
          keys,
          loading: false,
        };
  
      case UPDATE_KEY_FAILURE:
        return {
          ...state,
          updateKeyResult: { success: false, ...action.payload.error },
          loading: false,
        };
  
      case DELETE_KEY_SUCCESS:
      const filteredKeys = state.keys.Items.filter(key => key.keyId !== action.payload.keyId);
      return {
          ...state,
          deleteKeyResult: { success: true },
          keys: { Items: filteredKeys },
          loading: false,
      };
  
      case DELETE_KEY_FAILURE:
        return {
          ...state,
          deleteKeyResult: { success: false, ...action.payload.error },
          loading: false,
        };
  
      case GET_KEYBYID_SUCCESS:
        return {
          ...state,
          getKeyByIdResult: { success: true },
          selectedKey: action.payload.key,
          loading: false,
        };
  
      case GET_KEYBYID_FAILURE:
        return {
          ...state,
          getKeyByIdResult: { success: false, ...action.payload.error },
          selectedKey: null,
          loading: false,
        };
  
      case GET_KEY_KEYTYPE_SUCCESS:
        return {
          ...state,
          getKeyByTypeResult: { success: true },
          apiKey: action.payload.key,
          loading: false,
        };
  
      case GET_KEY_KEYTYPE_FAILURE:
        return {
          ...state,
          getKeyByTypeResult: { success: false, ...action.payload.error },
          apiKey: null,
          loading: false,
        };
      case GET_KEY_BY_TYPE_EXISTS_SUCCESS:
        return {
          ...state,
          getKeyByTypeExistsResult: { success: true },
          checkedKeys:true,
          keyExists: action.payload.key,
          loading: false,
        };
      case GET_KEY_BY_TYPE_EXISTS_FAILURE:
        return {
          ...state,
          getKeyByTypeExistsResult: { success: false, ...action.payload.error },
          checkedKeys:true,
          keyExists:false,
          loading: false,
        };
      case GET_USER_SYSTEM_KEY_PERMISSION_SUCCESS:
        // console.log("permission success",action.payload.permissions)
        return {
          ...state,
          getUserSystemKeyPermissionResult: { success: true },
          permission: action.payload.permissions
        };
      case GET_USER_SYSTEM_KEY_PERMISSION_FAILURE:
        return {
          ...state,
          getUserSystemKeyPermissionResult: { success: false, ...action.payload.error },
          permission: null
        };
  
      default:
        return state;
    }
  };
  